import { render, staticRenderFns } from "./ReferralsHistory.vue?vue&type=template&id=93bff56c&"
import script from "./ReferralsHistory.vue?vue&type=script&lang=js&"
export * from "./ReferralsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports